import { createContext } from "react";
import { Identifier } from "react-admin";
import { HosTimers } from "../hosUtils";

export interface IHosInfoContext {
  data: Map<Identifier, HosTimers>;
}

export interface IHosInfoSetterContext {
  setHosInfos?: React.Dispatch<React.SetStateAction<IHosInfoContext>>;
}

export const HosInfoContext = createContext<IHosInfoContext>({
  data: new Map<Identifier, HosTimers>(),
});

export const HosInfoSetterContext = createContext<IHosInfoSetterContext>({});
